import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { EventConfiguration } from '../../event-configuration.types';

@Component({
  selector: 'aos-description-detailed-column',
  template: `<span class="description-text">{{ item().description }}</span>`,
  styleUrl: './description-detailed-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescriptionDetailedColumnComponent {
  item = input.required<EventConfiguration>();
  column = input.required<TableColumn>();
}
